import React, { useState } from "react";
import { useOutletContext } from 'react-router-dom';
import Swal from "sweetalert2";
import HelmetSEO from '../../componentesEspeciales/helmetSEO';

function Soporte(){
    const { usuario, cargandoUsuario } = useOutletContext() || {};

    const [formulario, setFormulario] = useState({
      nombre: usuario?.nombre || "", 
      email: usuario?.email || "",
      asunto: "",
      mensaje: "",
    });

    const [cargandoEnvio, setCargandoEnvio] = useState(false);
    const [respuestaEnvio, setRespuestaEnvio] = useState({ tipo: "", mensaje: "" });

    const actualizarFormulario = (campo, valor) => {
      setFormulario((prev) => ({ ...prev, [campo]: valor }));
    };

    const enviarSoporte = async (e) => {
      e.preventDefault();

      const nombre = formulario.nombre.trim();
      const email = formulario.email.trim();
      const asunto = formulario.asunto.trim();
      const mensaje = formulario.mensaje.trim();

      if(!nombre || !email || !asunto || !mensaje){
        setRespuestaEnvio({ tipo: "danger", mensaje: "Completa todos los campos para enviar la solicitud." });
        return;
      }

      setCargandoEnvio(true);
      setRespuestaEnvio({ tipo: "", mensaje: "" });

      try{
        const respuesta = await fetch("/enviar-soporte", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            params: {
              nombre,
              email,
              asunto,
              mensaje,
              usuario: usuario?.username || "NA",
              idUsuario: usuario?.idUsuario || "NA",
            }
          }),
        });

        const data = await respuesta.json();

        if(!respuesta.ok || data?.enviado === false){
          setRespuestaEnvio({
            tipo: "danger",
            mensaje: data?.mensaje || "No fue posible enviar la solicitud. Intenta nuevamente.",
          });
          return;
        }
        setRespuestaEnvio({
          tipo: "success",
          mensaje: data?.mensaje || "Solicitud enviada correctamente. Te responderemos lo antes posible.",
        });

        await Swal.fire({
          icon: "success",
          title: "Éxito",
          text: data?.mensaje || "Solicitud enviada correctamente. Te responderemos lo antes posible.",
          customClass: {
            popup: 'mi-modal',
            confirmButton: 'mi-boton-confirmar',
            cancelButton: 'mi-boton-cancelar'
          }
        });

        window.location.reload();
      }
      catch(err){
        console.error("Error enviando soporte:", err);
        setRespuestaEnvio({
          tipo: "danger",
          mensaje: "No fue posible enviar la solicitud. También puedes escribirnos a soporte@zervicy.com.",
        });
      }
      finally{
        setCargandoEnvio(false);
      }
    };

    return(
    <>
      <HelmetSEO
        titulo="Soporte y ayuda | Zervicy"
        descripcion="Contacta al equipo de soporte de Zervicy para recibir ayuda con reservas, pagos, cuentas, vendedores o problemas dentro de la plataforma."
      />
      <div className="bg-light">
        <div className="container py-4 py-md-5">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-11">

              <div className="text-center mb-4 mb-md-5">
                <span className="badge rounded-pill px-3 py-2 mb-3" style={{backgroundColor: "var(--azul-logo-claro)", color: "white"}}>
                  Centro de ayuda
                </span>
                <h1 className="display-6 fw-bold mb-2" style={{color: "var(--color-text-primary)"}}>Soporte Zervicy</h1>
                <p className="text-muted mb-0 mx-auto" style={{maxWidth: 720}}>
                  Estamos aquí para ayudarte con tu cuenta, reservas, pagos, publicación de servicios o cualquier duda relacionada con la plataforma.
                </p>
              </div>

              <div className="row g-4 align-items-stretch">
                <div className="col-12 col-lg-7">
                  <div className="card border-0 shadow-sm h-100" style={{borderRadius: 18}}>
                    <div className="card-body p-4 p-md-5">
                      <div className="mb-4">
                        <h2 className="h4 fw-bold mb-2" style={{color: "var(--color-text-primary)"}}>Escríbenos</h2>
                        <p className="text-muted mb-0">
                          Completa el formulario y nuestro equipo recibirá tu solicitud directamente.
                        </p>
                      </div>

                      <form onSubmit={enviarSoporte}>
                        <div className="row g-3">
                          <div className="col-12 col-md-6">
                            <label className="form-label fw-semibold">Nombre</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Tu nombre"
                              value={formulario.nombre}
                              onChange={(e) => actualizarFormulario("nombre", e.target.value)}
                              required
                            />
                          </div>

                          <div className="col-12 col-md-6">
                            <label className="form-label fw-semibold">Correo</label>
                            <input
                              type="email"
                              className="form-control"
                              placeholder="tu@email.com"
                              value={formulario.email}
                              onChange={(e) => actualizarFormulario("email", e.target.value)}
                              required
                            />
                          </div>

                          <div className="col-12">
                            <label className="form-label fw-semibold">Asunto</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Ej: Necesito ayuda con una reserva"
                              value={formulario.asunto}
                              onChange={(e) => actualizarFormulario("asunto", e.target.value)}
                              required
                            />
                          </div>

                          <div className="col-12">
                            <label className="form-label fw-semibold">Mensaje</label>
                            <textarea
                              className="form-control"
                              rows="5"
                              placeholder="Cuéntanos qué sucedió y cómo podemos ayudarte."
                              value={formulario.mensaje}
                              onChange={(e) => actualizarFormulario("mensaje", e.target.value)}
                              required
                            />
                          </div>

                          {respuestaEnvio.mensaje && (
                            <div className="col-12">
                              <div className={`alert alert-${respuestaEnvio.tipo} mb-0`} role="alert">
                                {respuestaEnvio.mensaje}
                              </div>
                            </div>
                          )}

                          <div className="col-12">
                            <button
                              type="submit"
                              disabled={cargandoEnvio}
                              className="btn w-100 fw-semibold py-2"
                              style={{backgroundColor: "var(--naranja-cta)", color: "white", borderRadius: 12, opacity: cargandoEnvio ? 0.75 : 1}}
                            >
                              {cargandoEnvio ? "Enviando solicitud..." : "Enviar solicitud de soporte"}
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>

                <div className="col-12 col-lg-5">
                  <div className="card border-0 shadow-sm h-100" style={{borderRadius: 18, background: "linear-gradient(180deg, var(--color-bg-surface) 0%, var(--color-bg-surface-alt) 100%)"}}>
                    <div className="card-body p-4 p-md-5 d-flex flex-column">
                      <h2 className="h4 fw-bold mb-2" style={{color: "var(--color-text-primary)"}}>Canales de contacto</h2>
                      <p className="text-muted mb-4">
                        También puedes contactarnos directamente por correo o seguir nuestras redes sociales.
                      </p>

                      <div className="mb-4">
                        <div className="p-3 rounded-4 border bg-white">
                          <div className="small text-muted mb-1">Correo de soporte</div>
                          <a className="fw-semibold text-decoration-none" href="mailto:soporte@zervicy.com" style={{color: "var(--azul-logo-claro)"}}>
                            soporte@zervicy.com
                          </a>
                        </div>
                      </div>

                      <div className="row g-2">
                        <div className="col-12 col-sm-6">
                          <a className="btn btn-outline-primary w-100 d-flex align-items-center gap-2 justify-content-start" href="https://www.instagram.com/zervicy" target="_blank" rel="noreferrer">
                            <i className="bi bi-instagram"></i>
                            <span>Instagram</span>
                          </a>
                        </div>

                        <div className="col-12 col-sm-6">
                          <a className="btn btn-outline-primary w-100 d-flex align-items-center gap-2 justify-content-start" href="https://www.facebook.com/zervicy/" target="_blank" rel="noreferrer">
                            <i className="bi bi-facebook"></i>
                            <span>Facebook</span>
                          </a>
                        </div>

                        <div className="col-12 col-sm-6">
                          <a className="btn btn-outline-primary w-100 d-flex align-items-center gap-2 justify-content-start" href="https://www.tiktok.com/@zervicy" target="_blank" rel="noreferrer">
                            <i className="bi bi-tiktok"></i>
                            <span>TikTok</span>
                          </a>
                        </div>

                        <div className="col-12 col-sm-6">
                          <a className="btn btn-outline-primary w-100 d-flex align-items-center gap-2 justify-content-start" href="https://www.youtube.com/@zervicy" target="_blank" rel="noreferrer">
                            <i className="bi bi-youtube"></i>
                            <span>YouTube</span>
                          </a>
                        </div>

                        <div className="col-12 col-sm-6">
                          <a className="btn btn-outline-primary w-100 d-flex align-items-center gap-2 justify-content-start" href="https://wa.me/573189859423" target="_blank" rel="noreferrer">
                            <i className="bi bi-whatsapp"></i>
                            <span>WhatsApp</span>
                          </a>
                        </div>

                        <div className="col-12 col-sm-6">
                          <a className="btn btn-outline-primary w-100 d-flex align-items-center gap-2 justify-content-start" href="tel:+573124964754">
                            <i className="bi bi-telephone-fill"></i>
                            <span>Llamar</span>
                          </a>
                        </div>
                      </div>

                      <div className="mt-4 p-3 rounded-4" style={{backgroundColor: "rgba(var(--naranja-cta-rgb), 0.10)"}}>
                        <p className="small mb-0" style={{color: "var(--color-text-primary)"}}>
                          <b>Horario de atención:</b> responderemos lo antes posible. Para solicitudes relacionadas con pagos o reservas, incluye el mayor detalle posible.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </>
)
}

export default Soporte;